import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import TaxesForm from './form';
import { Deletemodel } from '../../Common/Functions';
import { getTax, deleteTax } from '../../../Utility/Api';
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { useLocation } from 'react-router-dom';

const Taxes_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [taxes, setTax] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState('');
  const [selectedTax, setSelectedTax] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const taxesPerPage = 200;

  useEffect(() => {
    fetchTax();
  }, []);

  const fetchTax = async () => {
    try {
      const response = await getTax();
      if (response.data && response.data.data) {
        setTax(response.data.data);
        console.log("Tax", response.data.data)
      } else {
        toast.error('No Tax found.');
      }
    } catch (error) {
      console.error('Error fetching Tax:', error);
      toast.error('Error fetching Tax');
    }
  };

  const openModal = (tax = null) => {
    setSelectedTax(tax);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteTax(deleteID);
      setDeleteModal(false);
      toast.error('Tax deleted successfully');
      await fetchTax();
    } catch (error) {
      console.error('Error deleting unit:', error);
      toast.error('Error deleting unit');
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Taxes List</h6>
          {!readonly && <button type="button" onClick={() => openModal()} className="btn btn-primary mb-0" style={{ fontFamily: 'poppins' }}>
            Add Tax
          </button>}
        </div>
        <hr className='mt-1' />


        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: '100%', fontFamily: 'poppins' }}>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Value</th>
                    {!readonly && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {taxes.map((tax, index) => (
                    <tr key={tax.id}>
                      <td>{(currentPage - 1) * taxesPerPage + index + 1}</td>
                      <td>{tax.title}</td>
                      <td>{tax.value}</td>
                      {!readonly && <td>
                        <img
                          src='/assets/images/icons/edit.png'
                          onClick={() => openModal(tax)}
                          height="20px"
                          alt="Edit"
                        />
                        <img
                          src='/assets/images/icons/delete.png'
                          className="mx-1"
                          onClick={() => {
                            setDeleteID(tax.id);
                            setDeleteModal(true);
                          }}
                          height="20px"
                          alt="Delete"
                        />
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {deleteModal && (
        <Deletemodel
          setShowModal={setDeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {showModal && (
        <TaxesForm
          tax={selectedTax}
          closeModal={() => setShowModal(false)}
          refreshList={fetchTax}
        />
      )}
    </div>
  );
};

export default Taxes_list;
